[
  {
    "level": 1,
    "xp": 120
  },
  {
    "level": 2,
    "xp": 551
  },
  {
    "level": 3,
    "xp": 1345
  },
  {
    "level": 4,
    "xp": 2533
  },
  {
    "level": 5,
    "xp": 4139
  },
  {
    "level": 6,
    "xp": 6181
  },
  {
    "level": 7,
    "xp": 8677
  },
  {
    "level": 8,
    "xp": 11640
  },
  {
    "level": 9,
    "xp": 15083
  },
  {
    "level": 10,
    "xp": 19018
  },
  {
    "level": 11,
    "xp": 23455
  },
  {
    "level": 12,
    "xp": 28404
  },
  {
    "level": 13,
    "xp": 33873
  },
  {
    "level": 14,
    "xp": 39871
  },
  {
    "level": 15,
    "xp": 46406
  },
  {
    "level": 16,
    "xp": 53486
  },
  {
    "level": 17,
    "xp": 61117
  },
  {
    "level": 18,
    "xp": 69307
  },
  {
    "level": 19,
    "xp": 78061
  },
  {
    "level": 20,
    "xp": 87387
  },
  {
    "level": 21,
    "xp": 97288
  },
  {
    "level": 22,
    "xp": 107773
  },
  {
    "level": 23,
    "xp": 118845
  },
  {
    "level": 24,
    "xp": 130510
  },
  {
    "level": 25,
    "xp": 142774
  },
  {
    "level": 26,
    "xp": 155640
  },
  {
    "level": 27,
    "xp": 169114
  },
  {
    "level": 28,
    "xp": 183201
  },
  {
    "level": 29,
    "xp": 197905
  },
  {
    "level": 30,
    "xp": 213229
  },
  {
    "level": 31,
    "xp": 229180
  },
  {
    "level": 32,
    "xp": 245760
  },
  {
    "level": 33,
    "xp": 262973
  },
  {
    "level": 34,
    "xp": 280824
  },
  {
    "level": 35,
    "xp": 299316
  },
  {
    "level": 36,
    "xp": 318454
  },
  {
    "level": 37,
    "xp": 338240
  },
  {
    "level": 38,
    "xp": 358678
  },
  {
    "level": 39,
    "xp": 379772
  },
  {
    "level": 40,
    "xp": 401525
  },
  {
    "level": 41,
    "xp": 423941
  },
  {
    "level": 42,
    "xp": 447022
  },
  {
    "level": 43,
    "xp": 470773
  },
  {
    "level": 44,
    "xp": 495196
  },
  {
    "level": 45,
    "xp": 520293
  },
  {
    "level": 46,
    "xp": 546070
  },
  {
    "level": 47,
    "xp": 572527
  },
  {
    "level": 48,
    "xp": 599669
  },
  {
    "level": 49,
    "xp": 627498
  },
  {
    "level": 50,
    "xp": 656017
  },
  {
    "level": 51,
    "xp": 685228
  },
  {
    "level": 52,
    "xp": 715135
  },
  {
    "level": 53,
    "xp": 745741
  },
  {
    "level": 54,
    "xp": 777047
  },
  {
    "level": 55,
    "xp": 809057
  },
  {
    "level": 56,
    "xp": 841772
  },
  {
    "level": 57,
    "xp": 875197
  },
  {
    "level": 58,
    "xp": 909332
  },
  {
    "level": 59,
    "xp": 944181
  },
  {
    "level": 60,
    "xp": 979747
  }
]
